export default __webpack_public_path__ + "static/HeldaneDisplayWeb-Regular-4050cba32367cd0aa4140b586ade95d6.woff2";